/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect } from "react";
import { Field, Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";

import APP_CONST from "../../shared/constants";
import {
  ViedocButtonElement,
  ViedocMenuItemElement,
  ViedocSelectElement,
} from "../../../secure/elements/ViedocReactElements";
import FileDownload from "../../components/shared/FileDownload/FileDownload";
import { getMilestoneGroupLabel } from "../../../../utils/utilsHelper";

import * as templateActions from "../../../store/actions/templateActions";
import { useTranslation } from "react-i18next";
import Loader from "../../components/shared/Loader/Loader";

const AuditTrail = ({ setShowPlaceholderComponent }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    siteList,
    countryList,
    isArchiveLoading,
    milestoneGroupList,
    latestArchiveInfo,
    isCancelBeforeSuccess,
    mileStoneListWithGroup
  } = useSelector((store) => store.template);

  let countryPayload, sitePayload, milestoneListPayload, milestoneGroupPayload;

  const countryMapping = [
    {
      value: "All countries",
      label: t("ARCHIVE.PLACEHOLDER_ALLCOUNTRY"),
      code: "ALL",
    },
    ...countryList.map((country) => ({
      value: country.country,
      label: country.country,
      code: country.countryCode,
    })),
  ];

  const siteMapping = [
    {
      value: "All sites",
      label: t("ARCHIVE.PLACEHOLDER_ALLSITES"),
      code: "ALL",
    },
    ...siteList.map((siteName) => ({
      value: siteName.siteName,
      label: siteName.siteName,
      code: siteName.guid,
    })),
  ];
  const milestoneGroupData = [
    {
      value: "All milestones",
      label: t("ARCHIVE.PLACEHOLDER_ALLMILESTONES"),
      code: "ALL",
    }
  ];

  const milestoneMapping = [
    ...milestoneGroupData,
    ...(mileStoneListWithGroup?.map((milestone) => ({
      value: milestone.name ? milestone.name : milestone.label,
      label: milestone.name ? milestone.name : getMilestoneGroupLabel(milestone.label),
      code: milestone.id ? milestone.id : milestone.label,
    })) || []),
  ];

  let trialLevelDocs = [
    {
      value: "Trial Level",
      label: t("ARCHIVE.PLACEHOLDER_TRIALLEVEL"),
    },
  ];

  let trialLevelDocuments = [trialLevelDocs[0]?.value];
  let countryLevelDocuments = [countryMapping[0]?.value];
  let siteLevelDocuments = [siteMapping[0]?.value];
  let milestoneFilter = [milestoneMapping[0]?.value];

  const trailLevelValue = [
    {
      className: "archive-dropdown pt-20",
      label: t("ARCHIVE.FORMLABEL_TRIALLEVELDOC"),
      name: "trial",
      size: "small",
      variant: "outline",
      placeholder: "Select values",
      mappingValues: trialLevelDocs,
    },
  ];

  const countryLevelValue = [
    {
      className: "archive-dropdown",
      label: t("ARCHIVE.FORMLABEL_COUNTRYLEVELDOC"),
      name: "country",
      size: "small",
      variant: "outline",
      placeholder: "Select values",
      mappingValues: countryMapping,
    },
  ];

  const siteLevelValue = [
    {
      className: "archive-dropdown",
      label: t("ARCHIVE.FORMLABEL_SITELEVELDOC"),
      name: "site",
      size: "small",
      variant: "outline",
      placeholder: "Select values",
      mappingValues: siteMapping,
    },
  ];

  const handleMultiSelect = (event, form, name) => {
    const { value } = event.target;

    form.change(name, value);

    if (name === "trial") {
      trialLevelDocuments = value;
    } else if (name === "country") {
      countryLevelDocuments = value;
      countryPayload = countryMapping
        .map((country) => {
          if (countryLevelDocuments.includes(country.value)) {
            return country.code;
          }
        })
        .filter((value) => value !== undefined);
    } else if (name === "site") {
      siteLevelDocuments = value;
      sitePayload = siteMapping
        .map((site) => {
          if (siteLevelDocuments.includes(site.value)) {
            return site.code;
          }
        })
        .filter((value) => value !== undefined);
    } else {
      milestoneFilter = value;
      milestoneGroupPayload = milestoneMapping
        .map((milestone) => {
          if (milestoneFilter.includes(milestone.value)) {
            return milestone.code;
          }
        })
        .filter(
          (value) =>
            value !== undefined &&
            ["ALL","Start Up", "Study Conduct", "Close Out", "Other"].includes(value)
        );
      milestoneListPayload = milestoneMapping
        .map((milestone) => {
          if (milestoneFilter.includes(milestone.value)) {
            return milestone.code;
          }
        })
        .filter(
          (value) =>
            value !== undefined &&
            !["Start Up", "Study Conduct", "Close Out", "Other"].includes(value)
        );
    }
  };

  const onSubmit = () => {
    setShowPlaceholderComponent(true);
    const fileGenerationPayload = {
      trial: trialLevelDocuments.includes(trialLevelDocs[0].value)
        ? ["Trial level"]
        : [],
      countries: countryPayload || ["ALL"],
      sites: sitePayload || ["ALL"],
      milestone: milestoneListPayload || ["ALL"],
      milestoneGroup: milestoneGroupPayload || ["ALL"],
      category: APP_CONST.TEXT_AUDIT,
    };
    dispatch(templateActions.setInitialAuditCancel(false))
    dispatch(templateActions.generateCompleteAuditTrail(fileGenerationPayload));
  };

  /* API call to download the generated file available
   * @params archiveInfo from Redux is passed as arguments
   */
  const downloadFileHandler = (fileDetailObj) => {
    const requestPayload = {
      id: fileDetailObj.id,
      filename: fileDetailObj.filename,
      category: fileDetailObj.category,
    };
    dispatch(templateActions.downloadCompleteAuditTrail(requestPayload));
  };

  const resetHandler = (form) => {
    trialLevelDocuments = [trialLevelDocs[0].value];
    countryLevelDocuments = [countryMapping[0].value];
    siteLevelDocuments = [siteMapping[0].value];
    milestoneFilter = [milestoneMapping[0].value];
    form.reset(APP_CONST.dataPayload);
  };

  const selectedValue = (name) => {
    if (name === "trial") {
      return trialLevelDocuments;
    } else if (name === "country") {
      return countryLevelDocuments;
    } else if (name === "site") {
      return siteLevelDocuments;
    } else {
      return milestoneFilter;
    }
  };

  //Function to pass as a component type for Field component of react-final-form
  const selectInput = ({
    formChange,
    mappingValues,
    fieldname,
    size,
    variant,
    placeholder,
  }) => {
    return (
      <ViedocSelectElement
        key={fieldname}
        name={fieldname}
        size={size}
        variant={variant}
        value={selectedValue(fieldname)}
        multiple
        placeholder={placeholder}
        onChange={formChange}
      >
        {mappingValues.map((option) => (
          <ViedocMenuItemElement
            selected={
              APP_CONST.MULTISELECT_VALUES.includes(option.value) ? true : null
            }
            value={option.value}
            key={option.value}
            className={ 
              fieldname === APP_CONST.TEXT_MILESTONE &&
              !(
                milestoneGroupList?.result?.includes(option.value) ||
                option.value === APP_CONST.TEXT_ALL_MILESTONE
              )
                ? "menu-list-separation"
                : ""
            }
          >
            {option.label}
          </ViedocMenuItemElement>
        ))}
      </ViedocSelectElement>
    );
  };

  /* Render the Cancel and Generate button in return statement
   * @params pristine, invalid and form are passed as arguments
   */
  const renderFormButtons = (pristine, invalid, form) => {
    return (
      <div className="archive-box">
        <ViedocButtonElement
          size="small"
          variant="neutral"
          disabled={pristine || invalid}
          class="mr-10 pl-20"
          onClick={() => resetHandler(form)}
          title={t("ARCHIVE.BUTTON_RESET")}
        >
          {t("ARCHIVE.BUTTON_RESET")}
        </ViedocButtonElement>
        <ViedocButtonElement
          size="small"
          variant="success"
          disabled={invalid}
          onClick={onSubmit}
          title={t("ARCHIVE.BUTTON_GENERATE")}
        >
          {t("ARCHIVE.BUTTON_GENERATE")}
        </ViedocButtonElement>
      </div>
    );
  };

  useEffect(() => {
    if (isCancelBeforeSuccess) return;
    dispatch(templateActions.getCountry());
    dispatch(templateActions.getSite());
    dispatch(templateActions.getMilestoneDropDownData());
    dispatch(templateActions.getMilestoneGroup());
    dispatch(templateActions.getTimeFormat());
  }, []);

  const renderDocumentFilters = (form) => {
    return (
      <>
        {trailLevelValue.map((fieldValue) => (
          <div key={fieldValue.name} className={fieldValue.className}>
            <label>{fieldValue.label}:</label>
            <Field
              fieldname={fieldValue.name}
              name={fieldValue.name}
              size={fieldValue.size}
              variant={fieldValue.variant}
              component={selectInput}
              placeholder={fieldValue.placeholder}
              formChange={(event) =>
                handleMultiSelect(event, form, fieldValue.name)
              }
              mappingValues={fieldValue.mappingValues}
            />
          </div>
        ))}
        {countryLevelValue.map((fieldValue) => (
          <div key={fieldValue.name} className={fieldValue.className}>
            <label>{fieldValue.label}:</label>
            <Field
              fieldname={fieldValue.name}
              name={fieldValue.name}
              size={fieldValue.size}
              variant={fieldValue.variant}
              component={selectInput}
              placeholder={fieldValue.placeholder}
              formChange={(event) =>
                handleMultiSelect(event, form, fieldValue.name)
              }
              mappingValues={fieldValue.mappingValues}
            />
          </div>
        ))}
        {siteLevelValue.map((fieldValue) => (
          <div key={fieldValue.name} className={fieldValue.className}>
            <label>{fieldValue.label}:</label>
            <Field
              fieldname={fieldValue.name}
              name={fieldValue.name}
              size={fieldValue.size}
              variant={fieldValue.variant}
              component={selectInput}
              placeholder={fieldValue.placeholder}
              formChange={(event) =>
                handleMultiSelect(event, form, fieldValue.name)
              }
              mappingValues={fieldValue.mappingValues}
            />
          </div>
        ))}
      </>
    );
  };

  const renderMilestoneFilter = (form) => {
    return (
      <div className="archive-dropdown">
        <label>{t("ADMIN.ADMINTAB_MILESTONE")}:</label>
        <Field
          fieldname={"milestones"}
          name="milestones"
          size="small"
          variant="outline"
          component={selectInput}
          placeholder="Select values"
          formChange={(event) => handleMultiSelect(event, form, "milestones")}
          mappingValues={milestoneMapping}
        />
      </div>
    );
  };

  return (
    <>
      {isArchiveLoading ? (
        <Loader />
      ) : (
        <>
          <FileDownload
            downloadFileHandler={downloadFileHandler}
            category={APP_CONST.TEXT_AUDIT}
            latestArchiveInformation={latestArchiveInfo}
          />
        </>
      )}
      <>
        <Form
          onSubmit={onSubmit}
          mutators={{}}
          initialValues={APP_CONST.dataPayload}
          render={({ handleSubmit, pristine, invalid, form }) => (
            <form onSubmit={handleSubmit}>
              <div className="archive-content pl-30 pt-30">
                <h3>{t("ARCHIVE.TEXT_GENERATENEWFILE")}</h3>
                <h5 className="light-grey pt-20">
                  {t("ARCHIVE.TEXT_INCLUDE")}
                </h5>

                {renderDocumentFilters(form)}

                <div className="archive-dropdown pt-30">
                  <h5 className="light-grey pt-20">
                    {t("ARCHIVE.FORMLABEL_FILTERBY")}
                  </h5>
                </div>

                {renderMilestoneFilter(form)}
              </div>
              {renderFormButtons(pristine, invalid, form)}
            </form>
          )}
        />
      </>
    </>
  );
};

export default AuditTrail;
